import { render } from "./ApprovalVideoPreview.vue?vue&type=template&id=5be2a76b&scoped=true"
import script from "./ApprovalVideoPreview.vue?vue&type=script&lang=js"
export * from "./ApprovalVideoPreview.vue?vue&type=script&lang=js"

import "./ApprovalVideoPreview.vue?vue&type=style&index=0&id=5be2a76b&scoped=true&lang=css"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be2a76b"],['__file',"ApprovalVideoPreview.vue"]])

export default __exports__